export default __webpack_public_path__ + "static/media/Mask Group 3@2x.0ffb8739.png";